<div class="w-[70vw]">
  <h2 mat-dialog-title class="flex items-center mt-3">
    @if (isVanillaServer) {
      {{ message('restoreDefaultConfigHeader') }}
    } @else {
      {{ message('newServerConnectionHeader') }}
    }
    <button class="material-icons ml-2 text-2xl cursor-help hover:opacity-80"
            [matTooltip]="message('serverImportTooltip')">
      help_outline
    </button>
    <span class="ml-auto material-icons cursor-pointer hover:opacity-80" (click)="close()">close</span>
  </h2>
  <mat-dialog-content>
    <div class="flex items-center mb-4">
      <span class="material-icons mr-2">warning_amber</span>
      <span>
        {{ message('serverConnectionWarning') }}
      </span>
      <button mat-stroked-button class="ml-3 shrink-0" (click)="copyConfig()">
        <span class="material-icons text-base mr-1 align-middle">content_copy</span>
        {{ message('copyConfigButton') }}
      </button>
    </div>
    <form [class.hidden]="isVanillaServer" class="min-h-48">
      <mat-form-field appearance="outline" floatLabel="always" class="w-full my-2" subscriptSizing="dynamic">
        <mat-label>{{ message('serverNameLabel') }}</mat-label>
        <input #serverNameInput matInput [readonly]="!serverConfig.isCustom" [value]="draftServerName()"
               (input)="onServerNameInput(serverNameInput.value)">
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full my-2" floatLabel="always" subscriptSizing="fixed"
                      [hintLabel]="connectionFailed() ? message('serverConnectionError') : ''">
        <mat-label>{{ message('serverHostLabel') }}</mat-label>
        <input #serverHostNameInput matInput [readonly]="!serverConfig.isCustom" [value]="draftHostname()"
               (input)="onHostnameInput(serverHostNameInput.value)">
        <span matTextPrefix>http{{ draftUseInsecureHttp() ? '' : 's' }}://</span>
        @if (draftConnectionEstablished()) {
          <span matIconSuffix class="material-icons text-green">done</span>
        } @else if (connectionFailed()) {
          <span matIconSuffix class="material-icons text-red">error_outline</span>
        } @else {
          <span matIconSuffix class="material-icons">radio_button_unchecked</span>
        }

      </mat-form-field>
      <mat-checkbox [checked]="draftUseInsecureHttp()"
                    (change)="onUseInsecureHttpChange($event.checked)">
        {{ message('useInsecureHttpLabel') }}
      </mat-checkbox>
    </form>
    @if (connecting() || saving()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (newSkills().length > 0) {
      <mat-expansion-panel class="my-2">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ message('newSkillsHeader') }}: {{ newSkills().length }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ul>
            @for (skill of newSkills(); track $index) {
              <li>{{ skill.Skill }}</li>
            }
          </ul>
        </ng-template>
      </mat-expansion-panel>
    }
    @if (newTables().length > 0) {
      <mat-expansion-panel class="my-2">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ message('newCraftingTablesHeader') }}: {{ newTables().length }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ul>
            @for (table of newTables(); track $index) {
              <li>{{ table.Name }}</li>
            }
          </ul>
        </ng-template>
      </mat-expansion-panel>
    }
    @if (newItems().length > 0) {
      <mat-expansion-panel class="my-2">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ message('newItemsHeader') }}: {{ newItems().length }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ul>
            @for (item of newItems(); track $index) {
              <li>{{ item.PropertyInfos.DisplayName.LocString }}</li>
            }
          </ul>
        </ng-template>
      </mat-expansion-panel>
    }
    @if (newRecipes().length > 0) {
      <mat-expansion-panel class="my-2">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ message('newRecipesHeader') }}: {{ newRecipes().length }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ul>
            @for (recipe of newRecipes(); track $index) {
              <li class="mb-2">
                <h3>{{ recipe.Key }}</h3>
                <div class="ml-2 text-xs">
                  <span
                    [class.changed-recipe-element]="recipe.UpdatedSkillLevel">{{ message('levelLabel') }} {{ recipe.SkillLevel }} </span>
                  <span [class.changed-recipe-element]="recipe.UpdatedSkill">{{ recipe.SkillNameID }}, </span>
                  <span
                    [class.changed-recipe-element]="recipe.UpdatedLaborCost">{{ recipe.BaseLaborCost }} {{ message('calsUnit') }} </span>
                  <span
                    [class.changed-recipe-element]="recipe.UpdatedCraftingTable">{{ message('atLabel') }} {{ recipe.CraftingTable }}</span>
                  <br>
                  <span [class.changed-recipe-element]="recipe.UpdatedIngredients">{{ message('inputsLabel') }}: </span>
                  @for (input of recipe.Ingredients; track $index) {
                    <span
                      [class.changed-recipe-element]="input.UpdatedAmount || input.NewItem">{{ input.Ammount }} </span>
                    <span
                      [class.changed-recipe-element]="input.NewItem">{{ input.Name ? input.Name : input.Tag }} </span>
                    <span
                      [class.changed-recipe-element]="input.UpdatedStatic || input.NewItem">{{ input.IsStatic ? message('staticLabel') : message('reducibleLabel') }}</span>
                    @if ($index < recipe.Ingredients!.length - 1) {
                      ,
                    }
                  }
                  <br>
                  <span [class.changed-recipe-element]="recipe.UpdatedOutputs">{{ message('outputsLabel') }}: </span>
                  @for (output of recipe.Outputs; track $index) {
                    <span
                      [class.changed-recipe-element]="output.UpdatedAmount || output.NewItem">{{ output.Ammount }} </span>
                    <span [class.changed-recipe-element]="output.NewItem">{{ output.Name }} </span>
                    <span
                      [class.changed-recipe-element]="output.UpdatedStatic || output.NewItem">{{ output.IsStatic ? message('staticLabel') : message('reducibleLabel') }}</span>
                    @if ($index < recipe.Outputs!.length - 1) {
                      ,
                    }
                  }
                </div>
              </li>
            }
          </ul>
        </ng-template>
      </mat-expansion-panel>
    }
    @if (modifiedRecipes().length > 0) {
      <mat-expansion-panel class="my-2">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ message('modifiedRecipesHeader') }}: {{ modifiedRecipes().length }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ul>
            @for (recipe of modifiedRecipes(); track $index) {
              <li class="mb-2">
                <h3>{{ recipe.Key }}</h3>
                <div class="ml-2 text-xs">
                  <span
                    [class.changed-recipe-element]="recipe.UpdatedSkillLevel">{{ message('levelLabel') }} {{ recipe.SkillLevel }} </span>
                  <span [class.changed-recipe-element]="recipe.UpdatedSkill">{{ recipe.SkillNameID }}, </span>
                  <span
                    [class.changed-recipe-element]="recipe.UpdatedLaborCost">{{ recipe.BaseLaborCost }} {{ message('calsUnit') }} </span>
                  <span
                    [class.changed-recipe-element]="recipe.UpdatedCraftingTable">{{ message('atLabel') }} {{ recipe.CraftingTable }}</span>
                  <br>
                  <span [class.changed-recipe-element]="recipe.UpdatedIngredients">{{ message('inputsLabel') }}: </span>
                  @for (input of recipe.Ingredients; track $index) {
                    <span
                      [class.changed-recipe-element]="input.UpdatedAmount || input.NewItem">{{ input.Ammount }} </span>
                    <span
                      [class.changed-recipe-element]="input.NewItem">{{ input.Name ? input.Name : input.Tag }} </span>
                    <span
                      [class.changed-recipe-element]="input.UpdatedStatic || input.NewItem">{{ input.IsStatic ? message('staticLabel') : message('reducibleLabel') }}</span>
                    @if ($index < recipe.Ingredients!.length - 1) {
                      ,
                    }
                  }
                  <br>
                  <span [class.changed-recipe-element]="recipe.UpdatedOutputs">{{ message('outputsLabel') }}: </span>
                  @for (output of recipe.Outputs; track $index) {
                    <span
                      [class.changed-recipe-element]="output.UpdatedAmount || output.NewItem">{{ output.Ammount }} </span>
                    <span [class.changed-recipe-element]="output.NewItem">{{ output.Name }} </span>
                    <span
                      [class.changed-recipe-element]="output.UpdatedStatic || output.NewItem">{{ output.IsStatic ? message('staticLabel') : message('reducibleLabel') }}</span>
                    @if ($index < recipe.Outputs!.length - 1) {
                      ,
                    }
                  }
                </div>
              </li>
            }
          </ul>
        </ng-template>
      </mat-expansion-panel>
    }

    @if (serverConfig.id === 'default') {
      <span>{{ message('restoreDefaultConfigInfo') }}</span>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton (click)="close()">{{ message('cancelButton') }}</button>
    @if (!draftConnectionEstablished()) {
      <button matButton (click)="connect()"
              [disabled]="connecting() || draftHostname().trim().length === 0">{{ message('testConnectionButton') }}
      </button>
    } @else {
      <button matButton (click)="saveConnection()" [disabled]="saving()">{{ message('saveConnectionButton') }}</button>
    }

  </mat-dialog-actions>
</div>
